export const environment = {
  production: true,
  nau_url: 'https://naumatch.com.br/',
  mobile_url_nau: 'https://naumatch.tamboro.com.br/mobile/',
  web_url_nau: 'https://naumatch.tamboro.com.br/',
  url_api: 'https://new-match-api.tamboro.com.br/',
  auth_url_api: 'https://new-match-api.tamboro.com.br/auth/',

  googleUrl: `https://new-match-api.tamboro.com.br/google/login`
};
